import * as SiteType from '../types/site.types'

const fb = require('../../config/firebase.js');

export default {
  namespaced: true,
  state: {
      chats: undefined,
      rules: undefined,
  },
  getters: {
    getChats(state) {
      return state.chats;
    },
    getRules(state) {
      return state.rules;
    }
  },
  mutations: {
    [SiteType.CHATS_REQUEST] (state) {
      state.chats = undefined;
    },
    [SiteType.CHATS_SUCCESS] (state, payload) {
      let chats = payload.data();

      if(chats) {
        const keys = Object.keys(chats);
        chats = keys.map( (key) => {
          const chat = chats[key];
          chat.id = key;
          return chat;
        })
      }

      state.chats = chats;
    },
    [SiteType.RULES_REQUEST] (state) {
      state.rules = undefined;
    },
    [SiteType.RULES_SUCCESS] (state, payload) {
      if(!payload || !payload.data)
        state.rules = undefined;
      else
        state.rules = payload.data();
    },
    [SiteType.CLEAR_INFO] (state) {
      state.chats = undefined;
    }
  },
  actions: {
    async pullChats( { commit, state }) {
      commit(SiteType.CHATS_REQUEST);

      try {
        const querySnapshot = await fb.siteCollection
          .doc('chats')
          .get();

        if(!querySnapshot.exists) return undefined;

        await commit(SiteType.CHATS_SUCCESS, querySnapshot);
        return state.chats;
      } catch (e) {
        console.error(e);
        return undefined;
      }
    },
    async pullRules( { commit, state }) {
      commit(SiteType.RULES_REQUEST);

      try {
        const querySnapshot = await fb.siteCollection
          .doc('rules')
          .get();

        if(!querySnapshot.exists) return undefined;

        await commit(SiteType.RULES_SUCCESS, querySnapshot);
        return state.rules;
      } catch (e) {
        console.error(e);
        return undefined;
      }
    },
  }
}
